import { createFileRoute } from "@tanstack/react-router";
import { DocumentsSection } from "@/features/food-documents/documents-page";

export const Route = createFileRoute("/settings/documents/")({
  component: DocumentsListPage,
});

function DocumentsListPage() {
  return (
    <div className="w-5xl mx-auto px-6 py-8">
      <div className="space-y-1 mb-6">
        <h1 className="text-base font-semibold">Documents</h1>
        <p className="text-sm text-muted-foreground">
          Manage document templates used across the system.
        </p>
      </div>
      <DocumentsSection />
    </div>
  );
}
